<div class="card">
  <slot />
</div>

<style>
  .card {
    box-sizing: border-box;
    overflow: hidden;
    padding: 0.8rem 1rem;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.125);
  }
</style>
